import { COLORS } from '@btime/constants'
import { compose, head, prop, toLower } from 'ramda'
import { getExtension } from '@btime/helpers'
import { useDropzone } from 'react-dropzone'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Title } from '../../../../components/presentation/Text'
import { useSaveImport } from '../_requests/requestImport'
import { useUploadRequest } from '../../../../utils/hooks/uploadV2'
import Center from '../../../../components/helpers/Center'
import Icon from '../../../../components/shapes/Icon'
import Loading from '../../../../components/helpers/Loading'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'

const DropFilePanel = ({ onStartImport, entity }) => {
  const { t } = useTranslation('import')
  const [importDoc, { loading }] = useSaveImport(onStartImport)

  const [upload, docState] = useUploadRequest(values => {
    importDoc({ inputDocumentId: head(values)?.id, entity })
  })

  const onDrop = files => {
    const extension = compose(toLower, getExtension, prop('name'), head)(files)
    if (extension !== 'xlsx') return alert(t('fileNotSupported'))
    upload(files)
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: '.csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
  })

  if (loading || docState.loading)
    return (
      <Panel flex={12} noMargin>
        <Center>
          <Loading />
        </Center>
      </Panel>
    )

  return (
    <Panel flex={12} noMargin borderColor={isDragActive && COLORS.green}>
      <div {...getRootProps()} style={{ height: '100%' }}>
        <input {...getInputProps()} />
        <Center>
          <Icon name="RiUploadCloud2Line" color={COLORS.dark3} size="3rem" />
          <Separator weight={6} />

          <Title size="h6" align="center" weight="400" maxWidth={11}>
            {t('dragExcelHere')}
          </Title>
        </Center>
      </div>
    </Panel>
  )
}

export default DropFilePanel
